import axios from 'axios'
import { Notice } from 'iview';
import router from '@/router'
const title='派智知产管家'
axios.defaults.timeout =  5000;
axios.interceptors.request.use(config => {
        let arr=[
            "api/pub/config",
            "api/pub/send_sms",
            "api/client/login",
            "api/client/reset_pwd",
        ]
        if( !arr.includes(config.url) ){
            if(!localStorage.getItem('client_id')  || !localStorage.getItem('token')){
                logout()
                Notice.error({
                    title,
                    desc: '登录超时'
                })
                return 
            }
            if(!config.data) config.data={}
            config.data.client_id=localStorage.getItem('client_id')
            config.data.reg_type=1
            if(config.data.page && !config.data.list_rows)  config.data.list_rows=10

        }
        config.headers['http-x-token'] = localStorage.getItem('token') || ''
        return config;
    },err => {
        Notice.error({
            title,
            desc: '客户端通讯出错'
        })
        return Promise.resolve(err);
    }
)

axios.interceptors.response.use(res => {
    const url=['fjapi/index/service/tianyancha_company','api/pub/craw_query']
    if( !url.includes(res.config.url) ){
        if(!res.data){  //没有任何数据
            Notice.error({
                title,
                desc: '服务器没有响应'
            })
            return  
        }
        switch(res.data.code){
            case 0:
                return res.data
            case 1:   
                Notice.error({
                    title,
                    desc: res.data.msg || '业务数据异常'  
                })
                break
            case 401:
            case 402:
            case 403:
                localStorage.clear()
                sessionStorage.clear()
                router.push('login')
                Notice.error({
                    title: '派智知识产权平台',
                    desc: '登录超时，请重新登录'
                })
            case 404:
                Notice.error({
                    title,
                    desc: res.data.msg || '接口签名错误'  
                })
                break
            case 405:
                Notice.error({
                    title,
                    desc: res.data.msg || '接口签名超时'  
                })
                break
            default:
                Notice.error({
                    title,
                    desc: res.data.msg ||'数据异常' 
                })
                break 
        }
    }else{
        return res.data
    }
    },err => {
        console.log(err);
        Notice.close('w500')
        Notice.error({
            name:'w500',
            title,
            desc: '网络通信不畅，请重试',
        })
    }

)
const logout=function(){
    localStorage.clear()
    sessionStorage.clear()
    router.push('login')
}

const comp_EXP= function(){  //验证是否过期 jwt是否存在
    let now=Number(Date.parse(new Date()).toString().substr(0,10))
    let exp=localStorage.getItem('expTime')
     if( localStorage.getItem('token') && now < exp ){
        if( (exp-now) <600 ){
            axios.post('api/client/refresh_token',{token:localStorage.getItem('token')})
            .then(res=>{
                if(res){
                    localStorage.setItem('token',res.data.token)
                    localStorage.setItem('expTime',res.data.exp)
                }
            })
        }
        return true;
     }
    else{
        localStorage.clear();
        sessionStorage.clear()
        return false;
    }
}
const sendSMS=function(data){  //发送短信 reg,forget_pwd
    data.type='雇主端'
    return axios.post('api/pub/send_sms',data);
}
const reset_pwd=function(data){  
    return axios.post('api/client/reset_pwd',data);
}
const login=function(data){   
    return axios.post('api/client/login',data);
}
const message=function(data){   //获取顶部消息
    return axios.post('api/client/message',data)
}
const userinfo = function (data) { // 用户信息
    return axios.post("api/client/userinfo", data) 
}
const create_order = function (data) { // 创建充值订单
    return axios.post("api/client/create_order", data) 
}
const balance = function (data) { // 交易明细
    return axios.post("api/client/balance", data) 
}
const editinfo = function (data) { //修改个人资料
    return axios.post("api/client/editinfo", data) 
}
const annual_fee_case_giveup = function (data) { //批量撤回
    return axios.post("api/client/annual_fee_case_giveup", data) 
}
const config = function (data) { //改变挖掘名称的案件状态
    return axios.post("api/pub/config", data) 
}
const red_dot = function () { //未读消息数量
    let data={ user_type:'雇主' }
    return axios.post('api/client/red_dot',data)  
}
const case_prepay_annual_fee_v2 = function (data) { //年费监控列表
    return axios.post('api/client/case_prepay_annual_fee_v2',data)  
}
const prepay_pay_year_v2 = function (data) { //年费监控 准备支付 单人
    return axios.post('api/client/prepay_pay_year_v2',data,{timeout:60000})   
}
const prepay_pay_year_multi_v2 = function (data) { //年费监控 准备支付 多人
    return axios.post('api/client/prepay_pay_year_multi_v2',data,{timeout:60000})   
}
const balance_pay_year_annual_fee = function (data) { //年费监控 付钱 单人
    return axios.post('api/client/balance_pay_year_annual_fee',data)  
}
const batch_pay_year_annual_fee = function (data) { //年费监控 付钱 单人
    return axios.post('api/client/batch_pay_year_annual_fee',data)  
}
const whitelist = function (data) {
    return axios.post('api/client/whitelist',data) 
}
const whitelist_add = function (data) {
    return axios.post('api/client/whitelist_add',data) 
}
const annual_fee_case_search_by_applicant = function (data) {
    return axios.post('api/client/annual_fee_case_search_by_applicant',data,{timeout:60000}) 
}
const annual_fee_case_add = function (data) {
    return axios.post('api/client/annual_fee_case_add',data) 
}
const annual_fee_case_add_by_apply_no = function (data) {
    return axios.post('api/client/annual_fee_case_add_by_apply_no',data,{timeout:60000}) 
}
const annual_fee_case_search_by_agent = function (data) {
    return axios.post('api/client/annual_fee_case_search_by_agent',data,{timeout:60000}) 
}
const annual_fee_remind_set_email = function (data) {
    return axios.post('api/client/annual_fee_remind_set_email',data) 
}
const annual_fee_remind_info = function (data) {
    return axios.post('api/client/annual_fee_remind_info',data) 
}
const annual_fee_remind_set = function (data) {
    return axios.post('api/client/annual_fee_remind_set',data) 
}
const annual_fee_remind_wxnickname = function (data) {
    return axios.post('api/client/annual_fee_remind_wxnickname',data) 
}
const recharge = function (data) {
    return axios.post('api/client/recharge',data) 
}
const case_prepay_annual_fee_info = function (data) {
    return axios.post('api/client/case_prepay_annual_fee_info',data) 
}
const buy_annual_fee_record = function (data) {
    return axios.post('api/client/buy_annual_fee_record',data) 
}
const cal_annual_fee_record = function (data) {
    return axios.post('api/client/cal_annual_fee_record',data) 
}
const annual_fee_case_addall = function (data) {
    return axios.post('api/client/annual_fee_case_addall',data,{timeout:600000}) 
}
const getAppliant = function (data) {  //获取申请人列表
    return axios.post("api/client/applicant", data)
}
const addAppliant=function(data){  //增加申请人
    return axios.post("api/client/add_applicant", data)
}

export  {
    comp_EXP,
    config,
    buy_annual_fee_record,
    cal_annual_fee_record,
    userinfo,
    whitelist,
    whitelist_add,
    annual_fee_case_search_by_applicant,
    annual_fee_case_add,
    annual_fee_case_add_by_apply_no,
    annual_fee_case_search_by_agent,
    case_prepay_annual_fee_info,
    annual_fee_remind_wxnickname,
    case_prepay_annual_fee_v2,
    annual_fee_case_giveup,
    annual_fee_remind_set_email,
    annual_fee_remind_info,
    annual_fee_remind_set,
    prepay_pay_year_multi_v2,
    prepay_pay_year_v2,
    balance_pay_year_annual_fee,
    batch_pay_year_annual_fee,
    balance,
    create_order,
    recharge,
    message,
    reset_pwd,
    sendSMS,
    editinfo,
    red_dot,
    login,
    annual_fee_case_addall,
    getAppliant,
    addAppliant
}


// WEBPACK FOOTER //
// ./src/assets/api.js